import { render } from "./createConfigDetail.vue?vue&type=template&id=33eb942a&scoped=true"
import script from "./createConfigDetail.vue?vue&type=script&lang=js"
export * from "./createConfigDetail.vue?vue&type=script&lang=js"

import "./createConfigDetail.vue?vue&type=style&index=0&id=33eb942a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33eb942a"]])

export default __exports__